'use client';

import { Button, Modal } from '@prickle/next-ui';
import { useUiStore } from '@tuning-bytes/data-access';
import { useTranslations } from 'next-intl';
import { startTransition } from 'react';
import { useShallow } from 'zustand/react/shallow';

export function NewsletterModal({
  dispatch,
}: {
  dispatch: (payload: FormData) => void;
}) {
  const isDisplaySuccesModal = useUiStore(
    useShallow((state) => state.isDisplaySuccesModal),
  );
  const setIsDisplaySuccesModal = useUiStore(
    (state) => state.setIsDisplaySuccesModal,
  );

  const formSubmitHandler = (withNewsletter = false) => {
    const emailInput = document.querySelector('input[name="email"]');
    const passwordInput = document.querySelector('input[name="password"]');
    const passwordConfimInput = document.querySelector(
      'input[name="passwordConfirm"]',
    );

    const newsletterInput = document.querySelector('input[name="newsletter"]');

    const email = emailInput?.getAttribute('value') as string;
    const password = passwordInput?.getAttribute('value') as string;
    const passwordConfirm = passwordConfimInput?.getAttribute(
      'value',
    ) as string;

    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('passwordConfirm', passwordConfirm);
    if (withNewsletter) {
      formData.append('newsletter', 'true');
      newsletterInput?.setAttribute('aria-checked', 'true');
      newsletterInput?.setAttribute('checked', 'true');
    }

    startTransition(() => {
      sessionStorage.setItem('newsletter-popup', 'true');
      dispatch(formData);
      setIsDisplaySuccesModal(false);
    });
  };

  const t = useTranslations('SignUpPage.NewsletterModal');

  return (
    <Modal
      isOpen={isDisplaySuccesModal}
      onClose={() => void 0}
      id="newsletter-confirmation"
      className="max-w-xl"
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col justify-center gap-2 md:gap-8">
          <h3 className="text-2xl font-bold text-center md:text-3xl">
            {t('title')}
          </h3>

          <p className="prose lg:prose-xl">{t('description')}</p>

          <p className="prose lg:prose-xl">{t('description-2')} </p>

          <p className="prose lg:prose-xl">{t('description-3')}</p>
        </div>
        <div className="flex flex-col justify-center gap-4 md:flex-row">
          <Button
            onClick={() => formSubmitHandler()}
            color="neutral"
            size="md"
            outline
          >
            {t('actions.no-subscribe')}
          </Button>

          <Button
            onClick={() => formSubmitHandler(true)}
            color="primary"
            size="md"
            outline
          >
            {t('actions.subscribe')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
